import Qs from 'qs'
import request from '@/util/request'
import {
  JSON_CONFIG,
  FORM_CONFIG,
  getAPILangParam
} from '@/util/helper.js'

export function updateAvatar (requestBody) {
  return request({
    url: '/avatar',
    method: 'post',
    data: Qs.stringify(requestBody),
    header: FORM_CONFIG
  })
}

export function login (requestBody) {
  return request({
    url: '/login',
    method: 'post',
    data: Qs.stringify(requestBody),
    header: FORM_CONFIG
  })
}

export function verify (requestBody) {
  return request({
    url: '/',
    method: 'post',
    data: Qs.stringify(requestBody),
    header: FORM_CONFIG
  })
}

export function registerTokenIsValid (token) {
  return request({
    url: `/verify/${token}`,
    method: 'get',
    header: FORM_CONFIG
  })
}

export function getAgreement () {
  return request({
    url: '/policy',
    method: 'get',
    header: FORM_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}

export function register (requestBody) {
  return request({
    url: '/register',
    method: 'post',
    data: Qs.stringify(requestBody),
    header: FORM_CONFIG
  })
}

export function sendPasswordEmail (requestBody) {
  return request({
    url: '/resetPassword',
    method: 'post',
    data: Qs.stringify(requestBody),
    header: FORM_CONFIG
  })
}

export function resetPassword (requestBody) {
  return request({
    url: '/resetPassword',
    method: 'put',
    data: Qs.stringify(requestBody),
    header: FORM_CONFIG
  })
}

export function getProfile () {
  return request({
    url: '/profile',
    method: 'get',
    header: JSON_CONFIG
  })
}

export function getManagedDevices () {
  return request({
    url: '/profile/devices',
    method: 'get',
    header: JSON_CONFIG
  })
}

export function putUnBindDevice (deviceToken) {
  return request({
    url: '/profile/device/unbind',
    method: 'put',
    header: JSON_CONFIG,
    data: {
      deviceToken: deviceToken
    }
  })
}

export function loggedInSendPasswordEmail () {
  return request({
    url: '/resetPassword',
    method: 'post',
    header: FORM_CONFIG
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js